import FormItemInfo from "../Common/FormItemInfo";
import ProviderAttachments from "./ProviderAttachments/ProviderAttachments";

interface IProviderAttachmentProps {
  setBucketAttachments: any;
  handleDraftSave?: () => Promise<void>;
  isQuickRequest?: boolean;
}

function ProviderAttachmentForm(props: IProviderAttachmentProps) {
  const { setBucketAttachments, handleDraftSave, isQuickRequest } = props;

  return (
    <div className="flex-row">
      <div className="w-200 mr-xl mb-0 mb-sm-3">
        <FormItemInfo
          labelId="new-request.provider.uploadFreightDocuments"
          label="Upload freight documents"
          descId="new-request.provider.uploadFreightDocumentsInfo"
          description="Upload required freight documents to help the provider to speed up the process"
        />
      </div>

      <div style={{ flexGrow: 1, maxWidth: "550px" }}>
        <ProviderAttachments
          updateBucketAttachments={setBucketAttachments}
          handleDraftSave={handleDraftSave}
          isQuickRequest={isQuickRequest}
        />
      </div>
    </div>
  );
}

export default ProviderAttachmentForm;

ProviderAttachmentForm.defaultProps = {
  handleDraftSave: undefined,
  isQuickRequest: false,
};
